export default __webpack_public_path__ + "static/media/filters.53384bb4.svg";